<template>
  <div class="header">
      <div class="container">
          <div class="logo">
              <a class="img-logo"><img src="@/assets/images/logo.svg"></a>
          </div>
      </div>
  </div>
</template>
<script>

export default {
  name: 'Header',
  data: () => {
    return {
     
    }
  }
}
</script>
